import Second from './Second';
import CourseSection from './six';
import InvestInKnowledge from './eight';
import HeroSection from './herosection';
import PopularCourses from '../techcourses/popularcourse';
import StudyAbroadCourses from '../screens/four';
import IITNEETSection from '../screens/third';
import WhatsAppFloatingButton from '../livechat/whatsapp';
import CourseCarousel from './Third';
import InstructorPageme from "./Five";
import IITJAMPrograms from './iitjampage';
import LearningHubCards from "./learninghub";
//import SAPCoursesDemo from './sapcoursepage';
 import GatePreparationCarousel from './gatesection';
import WorkshopConference from './worksho_confer';
import FourthPage from "./fourth_page";
import CATraining from './ca_program';
import AboutInstitute from './about_section';
import TrainingTabs from './training_modules';
import VisionaryAISection from './vision_models';
import CukPage from './cuk_conference';

function HomePage(){
    return( 
    <>
     <div>
      <WhatsAppFloatingButton/>

    </div>
<HeroSection/>
 <AboutInstitute/>
<PopularCourses/>
<CukPage/>
<TrainingTabs/>
<CourseSection/>
<WorkshopConference/>
<CourseCarousel/>
<CATraining/>
 <FourthPage/> 
<IITNEETSection />
<StudyAbroadCourses />
<IITJAMPrograms />
<GatePreparationCarousel/>
<LearningHubCards />
<Second/> 
<InvestInKnowledge />
<InstructorPageme/>
<VisionaryAISection/> 
{/* <AppDownloadSection/>
<OtherApps/> */}

    </>

    );
}
export default HomePage;



